var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.5V16.6528L2.45833 15.1944V18.5H1ZM5.01042 18.5V12.7639L6.46875 11.3056V18.5H5.01042ZM9.02083 18.5V11.3056L10.4792 12.7882V18.5H9.02083ZM13.0312 18.5V12.7882L14.4896 11.3299V18.5H13.0312ZM17.0417 18.5V8.875L18.5 7.41667V18.5H17.0417ZM1 12.7639V10.6979L7.80556 3.94097L11.6944 7.82986L18.5 1V3.06597L11.6944 9.89583L7.80556 6.00694L1 12.7639Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.79d31973a3e94b02402b980393c5b9e6.svg";
export { ForwardRef as ReactComponent };